import { render } from "./DetalleMovimiento.vue?vue&type=template&id=03f6b28e&scoped=true"
import script from "./DetalleMovimiento.vue?vue&type=script&lang=js"
export * from "./DetalleMovimiento.vue?vue&type=script&lang=js"

import "./DetalleMovimiento.vue?vue&type=style&index=0&id=03f6b28e&scoped=true&lang=scss"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f6b28e"]])

export default __exports__